module.exports = __webpack_public_path__ + "static/slack-icon-7c7d821281bcf969a7ca7fede34aa2aa.png";